{
  "name": "mdns-js",
  "version": "1.0.7",
  "repository": {
    "type": "git",
    "url": "git://github.com/mdns-js/node-mdns-js.git"
  },
  "description": "JavaScript/NodeJS mDNS discovery implementation",
  "keywords": [
    "mdns",
    "dns-sd",
    "zeroconf"
  ],
  "engines": {
    "node": ">= 6.0.0"
  },
  "main": "index.js",
  "dependencies": {
    "debug": "^4.1.1",
    "dns-js": "git+https://github.com/ciderapp/node-dns-js.git",
    "semver": "^7.2.3"
  },
  "devDependencies": {
    "code": "^5.2.4",
    "eslint": "^5.10.0",
    "joi": "^14.3.0",
    "lab": "^18.0.2"
  },
  "scripts": {
    "pretest": "node ./bin/testversion.js",
    "test": "./node_modules/.bin/lab --flat && npm run lint",
    "lint": "./node_modules/.bin/eslint test examples lib index.js",
    "doc": "jsdoc -d .\\doc index.js lib"
  },
  "author": {
    "name": "Peter Magnusson",
    "email": "peter@birchroad.net"
  },
  "contributors": [
    "James Sigurðarson <jamiees2@gmail.com> (http://jamessigurdarson.com)",
    "David Baldwynn <whitef0x0@users.noreply.github.com>",
    "Stefan Sauer <ensonic@google.com>"
  ],
  "license": "Apache-2.0",
  "bugs": {
    "url": "https://github.com/mdns-js/node-mdns-js/issues"
  },
  "homepage": "https://github.com/mdns-js/node-mdns-js"
}
